// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Custom alert-type filter dropdown — shows 5 options, scrolls for the rest */

.src-js-pages-usageReportingContainer-components-alertTypeFilterDropdown-module__wrapper--jiiwe {
  position: relative;
  display: inline-block;
}

.src-js-pages-usageReportingContainer-components-alertTypeFilterDropdown-module__trigger--j_9LK {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 170px;
  height: 28px;
  padding: 2px 8px;
  background-color: #a8b0b8;
  border: 1px solid #ffffff;
  border-radius: 4px;
  color: #ffffff;
  font-size: 12px;
  line-height: 1.2;
  cursor: pointer;
  text-align: left;
}

.src-js-pages-usageReportingContainer-components-alertTypeFilterDropdown-module__triggerLabel--WzxDc {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.src-js-pages-usageReportingContainer-components-alertTypeFilterDropdown-module__chevron--qSJtT {
  flex-shrink: 0;
  width: 9px;
  height: 9px;
  border-right: 2px solid #ffffff;
  border-bottom: 2px solid #ffffff;
  transform: rotate(45deg);
  margin-top: -3px;
}

.src-js-pages-usageReportingContainer-components-alertTypeFilterDropdown-module__menu--RSsIB {
  position: absolute;
  top: calc(100% + 2px);
  left: 0;
  z-index: 20;
  width: 170px;
  /* 5 rows × 28px = 140px; anything beyond scrolls vertically. */
  max-height: 140px;
  overflow-y: auto;
  background-color: #1e2d3d;
  border: 1px solid #3a4a5c;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
  padding: 0;
  margin: 0;
  list-style: none;
  /* Thin scrollbar (Firefox) */
  scrollbar-width: thin;
  scrollbar-color: #8a97a4 transparent;
}

.src-js-pages-usageReportingContainer-components-alertTypeFilterDropdown-module__menu--RSsIB::-webkit-scrollbar {
  width: 8px;
}

.src-js-pages-usageReportingContainer-components-alertTypeFilterDropdown-module__menu--RSsIB::-webkit-scrollbar-track {
  background: transparent;
}

.src-js-pages-usageReportingContainer-components-alertTypeFilterDropdown-module__menu--RSsIB::-webkit-scrollbar-thumb {
  background-color: #8a97a4;
  border-radius: 6px;
}

.src-js-pages-usageReportingContainer-components-alertTypeFilterDropdown-module__menu--RSsIB::-webkit-scrollbar-thumb:hover {
  background-color: #6f7d8c;
}

.src-js-pages-usageReportingContainer-components-alertTypeFilterDropdown-module__option--nikW1 {
  height: 28px;
  display: flex;
  align-items: center;
  padding: 0 10px;
  font-size: 12px;
  color: #c0ccda;
  cursor: pointer;
  white-space: nowrap;
}

.src-js-pages-usageReportingContainer-components-alertTypeFilterDropdown-module__option--nikW1:hover {
  background-color: rgba(255, 255, 255, 0.08);
}

.src-js-pages-usageReportingContainer-components-alertTypeFilterDropdown-module__optionSelected--oexYR {
  background-color: #FF9600;
  color: #0f1923;
  font-weight: 700;
}
`, "",{"version":3,"sources":["webpack://./src/js/pages/usageReportingContainer/components/alertTypeFilterDropdown.module.css"],"names":[],"mappings":"AAAA,8EAA8E;;AAE9E;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,WAAW;EACX,+BAA+B;EAC/B,gCAAgC;EAChC,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,WAAW;EACX,YAAY;EACZ,+DAA+D;EAC/D,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB","sourcesContent":["/* Custom alert-type filter dropdown — shows 5 options, scrolls for the rest */\n\n.wrapper {\n  position: relative;\n  display: inline-block;\n}\n\n.trigger {\n  display: inline-flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  width: 170px;\n  height: 28px;\n  padding: 2px 8px;\n  background-color: #a8b0b8;\n  border: 1px solid #ffffff;\n  border-radius: 4px;\n  color: #ffffff;\n  font-size: 12px;\n  line-height: 1.2;\n  cursor: pointer;\n  text-align: left;\n}\n\n.triggerLabel {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.chevron {\n  flex-shrink: 0;\n  width: 9px;\n  height: 9px;\n  border-right: 2px solid #ffffff;\n  border-bottom: 2px solid #ffffff;\n  transform: rotate(45deg);\n  margin-top: -3px;\n}\n\n.menu {\n  position: absolute;\n  top: calc(100% + 2px);\n  left: 0;\n  z-index: 20;\n  width: 170px;\n  /* 5 rows × 28px = 140px; anything beyond scrolls vertically. */\n  max-height: 140px;\n  overflow-y: auto;\n  background-color: #1e2d3d;\n  border: 1px solid #3a4a5c;\n  border-radius: 4px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);\n  padding: 0;\n  margin: 0;\n  list-style: none;\n  /* Thin scrollbar (Firefox) */\n  scrollbar-width: thin;\n  scrollbar-color: #8a97a4 transparent;\n}\n\n.menu::-webkit-scrollbar {\n  width: 8px;\n}\n\n.menu::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.menu::-webkit-scrollbar-thumb {\n  background-color: #8a97a4;\n  border-radius: 6px;\n}\n\n.menu::-webkit-scrollbar-thumb:hover {\n  background-color: #6f7d8c;\n}\n\n.option {\n  height: 28px;\n  display: flex;\n  align-items: center;\n  padding: 0 10px;\n  font-size: 12px;\n  color: #c0ccda;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.option:hover {\n  background-color: rgba(255, 255, 255, 0.08);\n}\n\n.optionSelected {\n  background-color: #FF9600;\n  color: #0f1923;\n  font-weight: 700;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `src-js-pages-usageReportingContainer-components-alertTypeFilterDropdown-module__wrapper--jiiwe`,
	"trigger": `src-js-pages-usageReportingContainer-components-alertTypeFilterDropdown-module__trigger--j_9LK`,
	"triggerLabel": `src-js-pages-usageReportingContainer-components-alertTypeFilterDropdown-module__triggerLabel--WzxDc`,
	"chevron": `src-js-pages-usageReportingContainer-components-alertTypeFilterDropdown-module__chevron--qSJtT`,
	"menu": `src-js-pages-usageReportingContainer-components-alertTypeFilterDropdown-module__menu--RSsIB`,
	"option": `src-js-pages-usageReportingContainer-components-alertTypeFilterDropdown-module__option--nikW1`,
	"optionSelected": `src-js-pages-usageReportingContainer-components-alertTypeFilterDropdown-module__optionSelected--oexYR`
};
export default ___CSS_LOADER_EXPORT___;
